import { Injectable } from '@angular/core';
import { IErrorService } from '@microsoft/applicationinsights-angularplugin-js';

/**
 * Custom ErrorHandler to handle dynamic module loading failures
 * Based on Angular official implementation: https://github.com/angular/angular/issues/56958
 */
@Injectable()
export class CustomErrorHandler implements IErrorService {
  constructor() {}

  handleError(error: any): void {
    if (typeof error.message === 'string') {
      // Get the first line of the error message (ignoring the call stack part)
      const firstLine = error.message.split('\n')[0];

      // Check for dynamic module loading failures or chunk loading errors
      if (/Failed to fetch dynamically imported module/.exec(firstLine) ||
          /chunk-(.*?)\.js/.exec(firstLine)) {
        window.location.reload();
        return;
      }
    }
  }
}
